import { z } from 'zod';
import { DAY_KEY_REGEX } from './constants.js';

/**
 * Body de POST /api/motus-daily/guess (spec games/motus-daily §5/§6).
 * `dayKey` = jour que le CLIENT croit jouer : s'il diffère du jour courant serveur,
 * la proposition est refusée (`409 day_over`) et le front refetch `today`.
 */
export const DailyGuessSchema = z
  .object({
    dayKey: z.string().regex(DAY_KEY_REGEX),
    word: z.string().min(1).max(20),
  })
  .strict();
export type DailyGuessInput = z.infer<typeof DailyGuessSchema>;
